<div class="delete-dialog">
    <div class="delete-dialog__header">
        <div>
            <span class="delete-dialog__eyebrow">
                SEGURIDAD DE TU CUENTA
            </span>
            <h2>
                ¿Eliminar tu cuenta?
            </h2>
        </div>
        <button type="button" class="delete-dialog__close" (click)="cancel()">
            <mat-icon>
                close
            </mat-icon>
        </button>
    </div>
    <div class="delete-dialog__content">
        <div class="delete-dialog__icon">
            <mat-icon>
                warning_amber
            </mat-icon>
        </div>
        <h3>
            Esta acción es irreversible
        </h3>
        <p>
            Al eliminar tu cuenta se borrará tu acceso a Nina
            y no podrás recuperar la información asociada a ella.
        </p>
        <p class="delete-dialog__question">
            ¿Estás seguro de que deseas continuar?
        </p>
    </div>
    <div class="delete-dialog__actions">
        <button type="button" class="delete-dialog__cancel" (click)="cancel()">
            No, conservar mi cuenta
        </button>
        <button type="button" class="delete-dialog__confirm" (click)="confirm()">
            Sí, eliminar mi cuenta
        </button>
    </div>
</div>